import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type {
	PetitionDetailsPsfOgImagesQuery,
	PetitionDetailsPsfOgImagesQueryVariables,
} from './getPetitionPsfOgImages.graphql';
import { PetitionDetailsPsfOgImages } from './getPetitionPsfOgImages.graphql';

type PsfOgImages = NonNullable<NonNullable<PetitionDetailsPsfOgImagesQuery['petitionBySlugOrId']>['psfOgImages']>;

/**
 * `images` is null when the petition is not eligible (an image is missing). A petition that is not found is kept apart,
 * because a link to a deleted petition is not an experiment problem.
 */
export type PetitionPsfOgImages =
	| Readonly<{ petitionFound: false }>
	| Readonly<{ petitionFound: true; images: PsfOgImages | null }>;

/**
 * The OG image arm images of a petition.
 */
export async function getPetitionPsfOgImages(
	slugOrId: string,
	{ gql: { fetch } }: UtilityContext,
): Promise<PetitionPsfOgImages> {
	const { data } = await fetch<PetitionDetailsPsfOgImagesQuery, PetitionDetailsPsfOgImagesQueryVariables>({
		query: PetitionDetailsPsfOgImages,
		variables: { slugOrId },
		rejectOnError: true,
	});
	if (!data.petitionBySlugOrId) return { petitionFound: false };
	return { petitionFound: true, images: data.petitionBySlugOrId.psfOgImages ?? null };
}
